module.exports = __webpack_public_path__ + "media/images/flags/16/Czech-Republic-5d2bc76019488cef05fbf1220e6e164d.png";